import React from 'react'

const HorizentalFlexBox = ({children, width = '100%', className, wrap = true}) => {
  let HFBClassName = 'row-flexbox' + (className ? ' ' + className : '')
  if (!wrap) HFBClassName += ' no-wrap'
  return (
    <div className={HFBClassName} style={{width}}>
      {children}
    </div>
  )
}

export default HorizentalFlexBox



// WEBPACK FOOTER //
// ../src/commons/components/SegmentsPopupContent/RowFlexBox.js